import Logo from "../Logo";
import { FiTwitter, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="pt-16 pb-8 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          <div>
            <Logo inverted className="h-10 mb-4" />
            <p className="text-gray-400 mb-4">
              Transforming social media content with AI-powered video solutions that engage, convert, and drive results.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/grapegraphai/" className="text-gray-400 hover:text-purple-400 transition-colors">
                <FiInstagram size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-sm text-gray-500 mb-4 md:mb-0">
            &copy; {currentYear} GrapeGraph.ai. All rights reserved.
          </div>
          <div className="flex space-x-6 text-sm">
            <a href="/privacy" className="text-gray-500 hover:text-purple-400 transition-colors">Privacy Policy</a>
            <a href="/tos" className="text-gray-500 hover:text-purple-400 transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
